import React, { Fragment, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AppsRoundedIcon from "@mui/icons-material/AppsRounded";
import Divider from "@mui/material/Divider";
import ghlogo from "./ghLogo.svg";
import fetchApi from "./fetchApi";
import SvgIcon from "@mui/material/SvgIcon";
import "./index.css";

const doNav = (p) => {
  // window.open(p, "_blank");
  window.location.assign(p);
};

export default function AppPicker(props) {
  const [menuItems, setMenuItems] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [display, setDisplay] = useState(true);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const createMenuItems = (data, queryString) => {
    const menuItems = (
      <Fragment>
        {data.map((elem, index) => {
          const icon = (
            <SvgIcon>
              <path d={`${elem.path}`} />
            </SvgIcon>
          );

          return (
            <Grid
              align="center"
              item
              sm={4}
              xs={12}
              key={index}
              onClick={(e) => doNav(`${elem.link}${queryString}`)}
              className="grid"
            >
              <Box
                sx={{
                  mt: 2,
                  height: 5,
                  width: 5,
                  maxHeight: { xs: 5, md: 5 },
                  maxWidth: { xs: 5, md: 5 },
                }}
                alt={`${elem.label}`}
              >
                {icon}
              </Box>
              <Box
                variant="text"
                href={`${elem.link}${queryString}`}
                sx={{
                  mt: 2,
                  mb: 2,
                  pl: 6,
                  pr: 4,
                }}
              >
                {elem.label}
              </Box>
            </Grid>
          );
        })}
      </Fragment>
    );
    data.length > 0 ? setMenuItems(menuItems) : setDisplay(false);
    const isAdUser = sessionStorage.getItem("isAdUser");
    if (isAdUser === "false" || !isAdUser) setDisplay(false);
  };

  const getApplicaionsEndpoint = () => {
    const hostname = window.location.hostname;
    try {
      // Use the Dev API in dev & local environments
      if (
        hostname.indexOf("dev") !== -1 ||
        hostname.indexOf("localhost") !== -1
      ) {
        // return `https://localhost:44321/auth/GetApplications`;
        return `https://dev.api.gateway.ghllc.com/auth/GetApplications`;
      }
      // QA API in QA environment
      else if (hostname.indexOf("qa") !== -1) {
        return `https://qa.api.gateway.ghllc.com/auth/GetApplications`;
      }
      //Test environment
      else if (hostname.indexOf("test") !== -1) {
        return `https://test.api.gateway.ghllc.com/auth/GetApplications`;
      }
      // Prod
      else {
        return `https://api.gateway.ghllc.com/auth/GetApplications`;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    const expires = sessionStorage.getItem("expires");
    const userName = sessionStorage.getItem("userName");
    const isAdUser = sessionStorage.getItem("isAdUser");
    const tempPass = sessionStorage.getItem("tempPass");
    const refreshToken = sessionStorage.getItem("refreshToken");

    //This should hit an API endpoint and get a list of apps
    //Payload will contain the icon, app name, and any other relevant data
    let apps;
    fetchApi("GET", getApplicaionsEndpoint())
      .then((response) => {
        if (response.status === 200) {
          apps = response.data;
          if (response.data.length <= 0) {
          }
          const queryString = `/?accessToken=${accessToken}&expires=${expires}&tokenExpirationDate=${expires}&refreshToken=${refreshToken}&isTempPassword=${tempPass}&isAdUser=${isAdUser}&username=${userName}`;
          createMenuItems(apps, queryString);
        } else {
          throw new Error(`Error Code ${response.status}`);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return display ? (
    props.gridOnly ? (
      <Paper elevation={4}>
        <Grid container maxwidth="lg">
          <Grid align="center" item sm={12} xs={12}>
            <Box
              sx={{
                mt: 5,
                width: 300,
                height: 300,
              }}
            >
              <Box
                component="img"
                sx={{
                  height: 233,
                  width: 350,
                  maxHeight: { xs: 233, md: 167 },
                  maxWidth: { xs: 350, md: 250 },
                }}
                alt="Global"
                src={ghlogo}
              />
              <Typography component="h1" align="center" gutterBottom>
                Please select an application to get started.
              </Typography>
            </Box>
            <Divider variant="middle" />
          </Grid>
          {menuItems}
        </Grid>
      </Paper>
    ) : (
      <Fragment>
        <Box
          sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
        >
          <Tooltip title="App Picker">
            <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
              <AppsRoundedIcon sx={{ width: 32, height: 32 }} />
            </IconButton>
          </Tooltip>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          sx={{
            zIndex: 100000,
          }}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <Grid container>{menuItems}</Grid>
        </Menu>
      </Fragment>
    )
  ) : (
    ""
  );
}
